/* eslint-disable react/prop-types */
import React, { useState } from "react";
import '../../../App.css';
import Homelayout from "../../layout/Homelayout";
import Style from '../css/HawkSoftStyle.module.scss';

export default function Loader(props){
    const { message } = props;
    return (
        // <div id="loading">
        //     <div id="loading-wrapper">
        //         <div id="loading-text">{message || ''}</div>
        //         <div id="loading-content"></div>
        //     </div>
        //     <div id="overlay"></div>
        // </div>
        <Homelayout>
            <div className={Style.title}>
                <h1 className="h4">Make a Payment</h1>
                <p>Please enter your payment information below.</p>
            </div>
        </Homelayout>
    );
};
